/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import AddressHelper from '../../OrderDetails/Helper/AddressHelper';

const DesktopShippingAddress = ({ ROSSRecipient, isROSSPassport }) => (
    <>
        <h2 className="gray-color no-margin-bottom">
            Recipient{' '}
            <div className="normal bold body-color no-uppercase margin-top-half">
                {ROSSRecipient.firstName} {ROSSRecipient.lastName}
            </div>
        </h2>

        <div className={ROSSRecipient.recipientEnable === 'true' ? 'no-margin-bottom min-height-100' : 'margin-bottom'}>
            {ROSSRecipient.businessName && !isROSSPassport ? (
                <div>{ROSSRecipient.businessName}</div>
            ) : (
                ''
            )}
            {ROSSRecipient.addressDetail?.[0] && !isROSSPassport ? (
                <AddressHelper
                    address={ROSSRecipient.addressDetail[0]}
                    phone={ROSSRecipient.phones[0].phone[0] || {}}
                />
            ) : (
                ''
            )}
        </div>
    </>
);

DesktopShippingAddress.defaultProps = {
    ROSSRecipient: {
        firstName: '',
        lastName: '',
        businessName: '',
    },
};

DesktopShippingAddress.propTypes = {
    ROSSRecipient: PropTypes.object,
    isROSSPassport: PropTypes.bool.isRequired,
};

export default DesktopShippingAddress;
